import { sendMessage } from '../../../config/utils/message'
import { CORE_API_AKADEMIK } from '../../key/api'

export async function getTagihan(nim) {
    const params = {
        nim: nim
    }
    try {
        const response = await CORE_API_AKADEMIK.get('tagihan/mahasiswa', { params: params })
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

export async function getRiwayatPembayaran(nim) {
    const params = {
        nim: nim
    }
    try {
        const response = await CORE_API_AKADEMIK.get('riwayat/pembayaran', { params: params });
        return response;
    } catch {
        sendMessage(500);
    }
}